import React from 'react';
import {ChangePasswordForm} from './form';
import {DeviceSize, useDeviceSize} from '../../../../shared/theme/helpers';
import {ChangePasswordMobile} from './mobile';
import {PasswordCreationForm} from '../../desktop/components/passwordCreationForm/PasswordCreationForm';
import {MobilePasswordCreation} from '../../mobile/components/passwordCreationForm/MobilePasswordCreation';

export const ProfileChangePassword: React.FC<{onFormSubmitted?: () => void}> = ({onFormSubmitted}) => {
  const deviceSize = useDeviceSize();
  return deviceSize === DeviceSize.desktop ? (
    <ChangePasswordForm onFormSubmitted={onFormSubmitted} />
  ) : (
    <ChangePasswordMobile />
  );
};

export const ProfileCreatePassword: React.FC<{onFormSubmitted?: () => void}> = ({onFormSubmitted}) => {
  const deviceSize = useDeviceSize();
  return deviceSize === DeviceSize.desktop ? (
    <PasswordCreationForm onSubmit={onFormSubmitted || (() => {})} />
  ) : (
    <MobilePasswordCreation onFormSubmitted={onFormSubmitted} />
  );
};
